module["exports"] = ["#{Name.last_name} #{suffix}", "#{Name.last_name} #{suffix}", "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"];